module.exports = __webpack_public_path__ + "static/media/loading_2.0836a709.gif";